import s from "../Account.module.css";
import React, {useState} from "react";
import BuyButton from "../../../assets/Components/StyledComponents/BuyButton";
import {readUserData, setUserInfo} from "../../../firebase";
import {checkData} from "../../../assets/Tools/checkData";
import {useDispatch, useSelector} from "react-redux";
import IsSended from "../../../assets/Components/isSended/isSended";
import {showSendMessage} from "../../../assets/Tools/showSendMessage/showSendMessage";
import {setUserData} from "../../../store/UserInfoSlice";


const EditAdress = () => {
    const [country, setCountry] = useState("");
    const [region, setRegion] = useState("");
    const [city, setCity] = useState("");
    const [address, setAddress] = useState("");
    const [isSended, setIsSended] = useState(false);


    const userId = useSelector(state => state.authUser.userId);
    const dispatch = useDispatch();


    const handleSubmit = (e) => {
        e.preventDefault();
        const data = {
            country,
            region,
            city,
            address
        }
        setUserInfo(userId, checkData(data));
        readUserData(userId).then((userInfo) => {
            dispatch(setUserData({
                name: userInfo.name,
                surname: userInfo.surname,
                phone: userInfo.phone,
                country: userInfo.country,
                region: userInfo.region,
                city: userInfo.city,
                address: userInfo.address,
            }))
        });
        setCountry("");
        setRegion("");
        setCity("");
        setAddress("");
        showSendMessage(setIsSended);
    }


    return (
        <div className={s.editProfile}>
            <h3>Изменить адрес</h3>
            {isSended ? <IsSended message="Данные успешно измененые"/> : null}
            <form onSubmit={(e) => handleSubmit(e)}>
                <div>
                    <h5>Страна:</h5>
                    <input value={country} onChange={(e) => setCountry(e.target.value)} type="text"/>
                </div>
                <div>
                    <h5>Область:</h5>
                    <input value={region} onChange={(e) => setRegion(e.target.value)} type="text"/>
                </div>
                <div>
                    <h5>Город:</h5>
                    <input value={city} onChange={(e) => setCity(e.target.value)} type="text"/>
                </div>
                <div>
                    <h5>Адрес:</h5>
                    <input value={address} onChange={(e) => setAddress(e.target.value)} type="text"/>
                </div>
                <div>
                    <BuyButton type="submit">ПРОДОЛЖИТЬ</BuyButton>
                </div>
            </form>
        </div>
    )
}


export default EditAdress;